function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Organization",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Contractor-detail-view",
  transform: "translate(-517.000000, -496.000000)",
  fill: "#E3E5EF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "file-signature-solid",
  transform: "translate(517.000000, 496.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.7861552,14.6098068 C19.3950126,15.6721076 18.6307576,17 17.414692,17 L1.58512359,17 C0.366715949,17 -0.394009529,15.670049 0.213660437,14.6098068 L8.12854361,0.796377117 C8.73769795,-0.266421711 10.2634041,-0.26449593 10.8714699,0.796377117 L18.7861552,14.6098068 Z M9.50000676,11.7539064 C8.66199484,11.7539064 7.98264608,12.4377248 7.98264608,13.2812502 C7.98264608,14.1247756 8.66199484,14.8085939 9.50000676,14.8085939 C10.3380187,14.8085939 11.0173674,14.1247756 11.0173674,13.2812502 C11.0173674,12.4377248 10.3380187,11.7539064 9.50000676,11.7539064 Z M8.05940474,6.26390251 L8.30409564,10.7795275 C8.31554182,10.9908322 8.48911468,11.1562502 8.69933511,11.1562502 L10.3006784,11.1562502 C10.5108988,11.1562502 10.6844717,10.9908322 10.6959179,10.7795275 L10.9406088,6.26390251 C10.9529786,6.03566423 10.7724456,5.84375016 10.5453693,5.84375016 L8.45461122,5.84375016 C8.2275349,5.84375016 8.04703495,6.03566423 8.05940474,6.26390251 L8.05940474,6.26390251 Z",
  id: "Shape"
}))));

function SvgExclamationTriangleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "17px",
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Warning!") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangleIcon);
export default __webpack_public_path__ + "static/media/exclamation-triangle-icon.c3c68021.svg";
export { ForwardRef as ReactComponent };